import { fetchDispatchDayContext } from "../lib/dataManagerApi.js";
import { buildDispatchDayControlsModel } from "./dispatchDayControls.js";
import {
  getDispatchMonthKey,
  normalizeDispatchMonthKey,
  resolveDefaultDispatchMonthKey,
} from "./dispatchDayCalendarUtils.js";

let cachedDispatchDayPayload = null;
let cachedDispatchDayPayloadPromise = null;

function normalizeText(value) {
  return typeof value === "string" ? value.trim() : "";
}

export function buildDispatchDayCalendarControlsFromPayload(payload, {
  activeDate = "",
  showArchive = false,
} = {}) {
  const dispatchDays = Array.isArray(payload?.dispatch_days)
    ? payload.dispatch_days
    : Array.isArray(payload?.dispatchDays)
      ? payload.dispatchDays
      : [];

  return buildDispatchDayControlsModel({
    activeDispatchDate: normalizeText(activeDate),
    dispatchDays,
    showArchive: showArchive === true,
  });
}

export async function loadDispatchDayContextPayload({ forceReload = false } = {}) {
  if (!forceReload && cachedDispatchDayPayload) {
    return cachedDispatchDayPayload;
  }

  if (!forceReload && cachedDispatchDayPayloadPromise) {
    return cachedDispatchDayPayloadPromise;
  }

  cachedDispatchDayPayloadPromise = fetchDispatchDayContext()
    .then((payload) => {
      cachedDispatchDayPayload = payload;
      cachedDispatchDayPayloadPromise = null;
      return payload;
    })
    .catch((error) => {
      cachedDispatchDayPayloadPromise = null;
      throw error;
    });

  return cachedDispatchDayPayloadPromise;
}

export function resetDispatchDayContextCache() {
  cachedDispatchDayPayload = null;
  cachedDispatchDayPayloadPromise = null;
}

export function resolveDispatchDayCalendarOpenMonthKey({
  activeDate = "",
  controls = null,
} = {}) {
  const items = Array.isArray(controls?.items) ? controls.items : [];
  const activeDateMonthKey = getDispatchMonthKey(activeDate);

  if (
    activeDateMonthKey
    && items.some((item) => getDispatchMonthKey(item?.dispatchDate) === activeDateMonthKey)
  ) {
    return activeDateMonthKey;
  }

  return resolveDefaultDispatchMonthKey({
    activeDate,
    activeDispatchMonth: controls?.activeDispatchMonth,
    items,
  });
}

export function resolveDispatchDayCalendarMonthKey({
  activeDate = "",
  activeMonthKey = "",
  controls = null,
} = {}) {
  const openMonthKey = resolveDispatchDayCalendarOpenMonthKey({
    activeDate,
    controls,
  });

  if (
    activeMonthKey
    && controls?.items?.some((item) => getDispatchMonthKey(item?.dispatchDate) === activeMonthKey)
  ) {
    return activeMonthKey;
  }

  return openMonthKey;
}

export { normalizeDispatchMonthKey };
